import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { Banner, QueryMegaMenuProductBannerArgs } from '@hdms/shared/common-types';

interface MegaMenuProductBannerResponse {
  megaMenuProductBanner: Banner;
}

@Injectable({
  providedIn: 'root'
})
export class MegaMenuProductBannerGqlService extends Query<
  MegaMenuProductBannerResponse,
  QueryMegaMenuProductBannerArgs
> {
  override document = gql`
    query MegaMenuProductBanner($filter: ProductBannerFilterInput, $localization: LocalizationInput!) {
      megaMenuProductBanner(filter: $filter, localization: $localization) {
        id
        overline
        headline
        mobileHeadline
        subHeadline
        body
        imageUri
        layout
        links {
          uri
          label
        }
        webAnalyticsData {
          trackCreative
          trackId
          trackName
        }
      }
    }
  `;
}
